const fragment = `
  id
  price
  isDefault
  palette {
    id
    name
    defaultImageUrl
  }
  buildingModel {
    id
    name
  }
`;

export const listBuildingModelPalettesQuery = `
  query ListBuildingModelPalettes(
    $filter: BuildingModelPaletteFilterInput
  ) {
    items: listBuildingModelPalettes(filter: $filter) {
      ${fragment}
    }
  }
`;

export const createBuildingModelPaletteQuery = `
  mutation CreateBuildingModelPalette(
    $input: CreateBuildingModelPaletteInput!
  ) {
    item: createBuildingModelPalette(input: $input) {
      ${fragment}
    }
  }
`;

export const updateBuildingModelPaletteQuery = `
  mutation UpdateBuildingModelPalette(
    $input: UpdateBuildingModelPaletteInput!
  ) {
    item: updateBuildingModelPalette(input: $input) {
      ${fragment}
    }
  }
`;

export const deleteBuildingModelPaletteQuery = `
  mutation DeleteBuildingModelPalette(
    $id: Int!
  ) {
    item: deleteBuildingModelPalette(id: $id) {
      ${fragment}
    }
  }
`;
